<template>
<div class="custom-border-table">
  <el-table
    class="egl-table sales-custom-table"
    style="width: 100%"
    :data="tableData"
    :border="true"
    :summary-method="getSummaries"
    show-summary
    :span-method="objectSpanMethod"
  >
    <el-table-column
      v-for="(item, idx) in tableLabel"
      :key="idx"
      :label="item.label"
      :prop="item.prop"
      :min-width="item.width"
      align='right'
      header-align='center'
    >
      <template slot-scope="scope">
        <template v-if="idx === 0">
          <div v-if="scope.$index === 0" class="row-group">現金売上</div>
          <template v-if="scope.$index === 1">
            <div class="row-group">売掛金売上</div>
            <td v-for="item in spanNameArr" :key="item"><span>{{ item }}</span></td>
          </template>
          <template v-if="scope.$index === 7">
            <div class="row-group">前受金売上</div>
            <td v-for="item in spanNameArr2" :key="item"><span>{{ item }}</span></td>
          </template>
        </template>
        <template v-else>
            {{ formatPrice(scope.row[scope.column.property]) }}
        </template>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
import { toThousands } from "@/utils/common";

export default {
  name: "custom-table",
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    accumulated: {
      type: Object,
      required: true,
    },
    isNegative: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      spanNameArr: ['窓口決済','オンライン 決済','全国共通券 着券','劇場引換券 着券','その他営収'],
      spanNameArr2: ['先売券着券','劇場前売券 着券'],
      tableLabel: [
        {
          width: 150,
          label: "売上精算",
        },
        {
          width: 130,
          label: "チケット",
          prop: "ticket",
        },
        {
          width: 130,
          label: "コンセ",
          prop: "concession",
        },
        {
          width: 130,
          label: "物販",
          prop: "commercial",
        },
        {
          width: 130,
          label: "会費",
          prop: "membershipFee",
        },
        {
          width: 130,
          label: "その他営収",
          prop: "otherRevenue",
        },
        {
          width: 130,
          label: "売上合計",
          prop: "salesTotal",
        },
        {
          width: 130,
          label: "先売券販売",
          prop: "preSalesTicket",
        },
        {
          width: 130,
          label: "先売コンセ／物販販売",
          prop: "preSalesItem",
        },
        {
          width: 130,
          label: "劇場前売券販売",
          prop: "advanceTicketSales",
        },
        {
          width: 130,
          label: "全国共通券販売",
          prop: "nationalTicketSales",
        },
        {
          width: 130,
          label: "収入合計",
          prop: "totalAmount",
        },
        {
          width: 130,
          label: "過不足",
          prop: "totalInsufficient",
        },
        {
          width: 130,
          label: "実収入合計",
          prop: "actualTotal",
        },
      ],
      spanArr: [],
      spanPosition: 0,
    };
  },
  created() {},
  mounted() {
    
  },
  methods: {
    getSummaries() {
      const sums = [ "合計" ];
      const values = Object.values(this.accumulated).map(item => item);
      values.forEach(value => {
        if (!isNaN(value)) {
          sums.push(this.formatPrice(value));
        }
      });
      return sums;
    },
    rowspan(spanArr, position, spanName) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1);
          position = 0;
        } else if (
          this.tableData[index][spanName] ===
          this.tableData[index - 1][spanName]
        ) {
          spanArr[position] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          position = index;
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    formatPrice(value) {
      return value !== null ? toThousands(value) + this.$locale("global.circle") : '-';
    },
  },
  watch: {
    accumulated: function(val) {
      this.$nextTick(() => {
        if (this.isNegative) {
          Object.keys(val).forEach(key => {
            if (key !== "type" && val[key] && val[key] > 0) {
              val[key] = 0 - val[key]
            }
          })
        }
      })
      this.spanArr = [];
      this.rowspan(this.spanArr, this.spanPosition, "type");
    },
    tableData(val) {
      this.$nextTick(() => {
        if (this.isNegative) {
          val.forEach(row => { 
            Object.keys(row).forEach(key => {
              if (key !== "type" && row[key] && row[key] > 0) {
                row[key] = 0 - row[key]
              }
            })
          });
        }
      })
    }
  }

};
</script>

<style lang="less">
.sales-custom-table{
  margin-bottom: 32px;
  .el-table__row {
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(8) {
      background-color: @secondly-orange;
      td {
        &:first-child {
          padding: 0;
          td {
            text-align: center;
            background-color: @pure-white;
          }
        }
      }
    }
    > td {
      &:first-child {
        padding: 0 10px;

        .cell {
          padding: 0 !important;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          td {
            width: calc(100% - 48px);
            border-right: 0;
            border-left: 1px solid @table-header-border;
            &:first-of-type {
              border-top: 1px solid @table-header-border;
            }
            &:nth-of-type(2),
            &:nth-of-type(3),
            &:nth-of-type(4){
              padding: 0 8px;
              height: 48px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            &:last-child {
              border-bottom: 0;
            }
          }
          .row-group {
            padding: 12px 0;
            text-align: center;
            width: 100%;
          }
        }
      }
      &:nth-child(5),
      &:nth-child(9),
      &:last-child {
        background-color: @secondly-orange;
      }
    }
  }

  .el-table__footer-wrapper tbody tr td {
    background-color: @secondly-yellow;
    color: @primary-black;
    &:first-child{
        text-align: center;
    }
  }
}
</style>